export enum FiltersHistorianSearch {
  FiscalCode = 1,
  SubjectData = 2,
  Matricola = 3,
  IdentityCard = 4,
}
